module.exports = __webpack_public_path__ + "static/media/des-iconsvg.e90e9716.svg";